import React, { memo } from 'react';
import { AssetItemDto } from '@api/Api';
import { ReactComponent as FolderSvg } from '@assets/icons/folder.svg';
import { ReactComponent as PrivateFolderSvg } from '@assets/icons/folder-private.svg';

import TilesViewItem from './TilesViewItem';

import './TilesView.less';

type TilesViewProps = {
  onSelectFolder: (folderId: string) => void;
  folders: {
    id: string;
    name: string;
    isPrivate: boolean;
  }[];
  assetsList: AssetItemDto[];
  isOpenFolder: boolean;
};
export default memo(function TilesView({
  onSelectFolder,
  folders,
  assetsList,
  isOpenFolder
}: TilesViewProps) {
  return (
    <div className="assets-tiles-view">
      {!!folders?.length && !isOpenFolder && (
        <div className="assets-tiles-view-folders">
          <div className="assets-tiles-view-label">Folders</div>
          <div className="assets-tiles-view-folders-list">
            {folders.map((folder) => {
              return (
                <div
                  className="assets-tiles-view-folder"
                  key={folder.id}
                  onClick={() => onSelectFolder(folder.id)}
                >
                  {folder.isPrivate ? <PrivateFolderSvg /> : <FolderSvg />}
                  {folder.name}
                </div>
              );
            })}
          </div>
        </div>
      )}
      {!!assetsList?.length && (
        <div className="assets-tiles-view-assets">
          <div className="assets-tiles-view-label">Assets</div>
          <div className="assets-tiles-view-assets-list">
            {assetsList.map((item) => {
              return <TilesViewItem key={item.id} asset={item} />;
            })}
          </div>
        </div>
      )}
    </div>
  );
});
